import { Check, X } from 'lucide-react';

import {
  PlatformFeature,
  PricingTier,
} from '@/pages/unauthenticated/pricing/components/types';
import { cn } from '@/lib/utils';

export function TierFeatureInTier({
  feature,
  tier,
}: {
  feature: PlatformFeature;
  tier: PricingTier;
}) {
  if (typeof feature.tiers[tier.name] === 'string') {
    return (
      <span
        className={cn('text-sm leading-6', {
          'font-semibold text-primary': tier.featured,
        })}
      >
        {feature.tiers[tier.name]}
      </span>
    );
  }

  /**
   * Tier contains the feature
   */
  if (feature.tiers[tier.name]) {
    return (
      <Check className="mx-auto h-5 w-5 text-primary" aria-hidden="true" />
    );
  }

  /**
   * Tier does not contain feature
   */
  return (
    <X className="mx-auto h-5 w-5 text-muted-foreground" aria-hidden="true" />
  );
}
